var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.62 2.24a.85.85 0 0 1 .76 0l8 4a.85.85 0 0 1 .47.76v10a.85.85 0 0 1-.47.76l-8 4a.85.85 0 0 1-.76 0l-8-4a.85.85 0 0 1-.47-.76V7a.85.85 0 0 1 .47-.76zM4.85 8.375l6.3 3.15v8.1l-6.3-3.15zm8 11.25 6.3-3.15v-8.1l-6.3 3.15zM12 10.05 18.1 7 12 3.95 5.901 7z",
  clipRule: "evenodd"
})));
export default SvgCube;